import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function OutstationToMumbaiLinks() {
  const [showLinks, setShowLinks] = useState(false);

  const toggleLinks = (e) => {
    e.preventDefault(); // Prevent page reload
    setShowLinks(!showLinks);
  };

  return (
    <div className='pt-4' >
      <a
        href="#"
        className="outstation-link mx-md-2 "
        onClick={toggleLinks}
      >
        <i className=" darkcolo"></i> Outstation to Mumbai Cabs
      </a>

      {showLinks && (
        <div className="outstation- mt-2">
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Mumbai-Innova-Crysta-Cab"><i className="fa fa-car darkcolo"></i> Pune to Mumbai Innova Crysta Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Mumbai-Sedan-Cab"><i className="fa fa-car darkcolo"></i> Pune to Mumbai Sedan Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Kondhwa-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Kondhwa to Mumbai Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Viman-Nagar-to-Mumbai-Cabs"><i className="fa fa-car darkcolo"></i> Viman Nagar to Mumbai Cabs</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Katraj-to-Mumbai-Cab-Service"><i className="fa fa-car darkcolo"></i> Katraj to Mumbai Cab Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Pune-Station-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolo"></i> Pune Station to Mumbai Cabs Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Boat-Club-Road-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Boat Club Road to Mumbai Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Vishrantwadi-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Vishrantwadi to Mumbai Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Alandi-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolo"></i> Alandi to Mumbai Cabs Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Wagholi-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Wagholi to Mumbai Cab</Link>
                        <Link className="mx-md-2 darkcoloo d-block" to="/Pune-to-Mumbai-Cabs"><i className="fa fa-car darkcolo"></i> Pune to Mumbai Cabs</Link>
       
         <Link className="mx-md-2 darkcoloo" to="/Wakad-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Wakad to Mumbai Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Hadapsar-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Hadapsar to Mumbai Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Kalyani-Nagar-to-Mumbai-Taxi"><i className="fa fa-car darkcolo "></i> Kalyani Nagar to Mumbai Taxi</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Koregaon-Park-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Koregaon Park to Mumbai Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Kothrud-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Kothrud to Mumbai Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Kharadi-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Kharadi to Mumbai Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Shivajinagar-to-Mumbai-Cab"><i className="fa fa-car darkcolo"></i> Shivajinagar to Mumbai Cab</Link>
                             
        </div>
      )}
    </div>
  );
}

export default OutstationToMumbaiLinks;
